import { request, METHOD, removeAuthorization } from '@/utils/request';
var BASE_URL = process.env.VUE_APP_API_BASE_URL;

/** 获取订单详情-基本信息
 * @param {Object} data
 */
export function getOrderDetailBasicInfos(data) {
  return request("".concat(BASE_URL) + "/order/main/".concat(data, "/basicInfos"), METHOD.GET);
}

/** 获取订单详情-基本信息-收货人信息
 * @param {Object} data
 */
export function getOrderAddress(data) {
  return request("".concat(BASE_URL) + "/order/address/" + data, METHOD.GET);
}

/** 获取订单详情-基本信息-客服备注
 * @param {Object} data
 */
export function getOrderServerNote(data) {
  return request("".concat(BASE_URL) + "/order/noteOfService/list", METHOD.GET, data);
}

/** 获取订单详情-基本信息-修改打印备注
 * @param {Object} data
 */
export function updateOrderNote(data) {
  return request("".concat(BASE_URL) + "/order/orderNote", METHOD.PUT, data);
}

/** 获取订单详情-订单明细
 * @param {Object} data
 */
export function getOrderDetailProducts(data) {
  return request("".concat(BASE_URL) + "/order/children/allInfo", METHOD.GET, data);
}

/** 获取订单详情-订单明细-获取订单状态履历
 * @param {Object} data
 */
export function getOrderStatusList(data) {
  return request("".concat(BASE_URL) + "/order/status/list/" + data, METHOD.GET);
}

/** 获取传票详情-物流信息-获取物流列表
 * @param {Object} data
 */
export function getOrderExpressList2(data) {
  return request("".concat(BASE_URL) + "/erporder/express/list/".concat(data), METHOD.GET);
}

/** 获取订单详情-物流运输方式
 * @param {Object} data
 */
export function getOrderTransportList(data) {
  return request("".concat(BASE_URL) + "/order/transport/list/".concat(data), METHOD.GET);
}

/** 获取订单详情-物流信息-删除物流列表
 * @param {Object} data
 */
export function deleteOrderExpress(data) {
  return request("".concat(BASE_URL) + "/order/express/".concat(data), METHOD.DELETE);
}

/** 获取订单详情-物流信息-新增物流列表
 * @param {Object} data
 */
export function addOrderExpress(data) {
  return request("".concat(BASE_URL) + "/order/express", METHOD.POST, data);
}

/** 获取传票详情-基本信息
 * @param {Object} data
 */
export function geterpOrderDetailBasicInfos(data) {
  return request("".concat(BASE_URL) + "/erporder/main/".concat(data, "/basicInfos"), METHOD.GET);
}

/** 获取传票明细tab数据 #151
 * @param {Object} data
 */
export function getOrderDetailProducts2(data) {
  return request("".concat(BASE_URL) + "/erporder/children/allInfo", METHOD.GET, data);
}